module.exports = __webpack_public_path__ + "static/design-workout.160b29f0.svg";